export const resizeImageMaintainAspect = async (
	file: File,
	maxSize: number,
): Promise<Blob> => {
	const img = new Image()
	img.src = URL.createObjectURL(file)

	await new Promise<void>((resolve, reject) => {
		img.onload = () => resolve()
		img.onerror = () => reject(new Error('Failed to load image'))
	})

	const { width, height } = img

	// Calculate new dimensions maintaining aspect ratio
	let newWidth = width
	let newHeight = height

	if (width > height) {
		if (width > maxSize) {
			newWidth = maxSize
			newHeight = (height * maxSize) / width
		}
	} else {
		if (height > maxSize) {
			newHeight = maxSize
			newWidth = (width * maxSize) / height
		}
	}

	// Create canvas with new dimensions
	const canvas = document.createElement('canvas')
	canvas.width = newWidth
	canvas.height = newHeight
	const ctx = canvas.getContext('2d')
	if (!ctx) throw new Error('Canvas context not available')

	ctx.drawImage(img, 0, 0, newWidth, newHeight)

	return await new Promise((resolve, reject) => {
		canvas.toBlob((blob) => {
			if (blob) resolve(blob)
			else reject(new Error('Failed to convert canvas to blob'))
		}, 'image/png')
	})
}
